export { default } from './Cognitive';
